import * as Push from 'push.js';
import i18n from 'i18next';
import defer from 'lodash/defer';

export const hasNotificationsPermission = Push.Permission.has();

// this prevents the yay successfully enabled notification showing twice in a session
// where a user has just accepted notifications in tribe
let hasRequestedInSession = false;

export const requestNotificationsPermission = () => {
  const hasPermission = hasNotificationsPermission;

  if (!hasPermission && !hasRequestedInSession) {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      Push.Permission.request();
    } else {
      Push.Permission.request(() => {
        hasRequestedInSession = true;
        Push.create(i18n.t('chat.desktop-notifications-enableb-successfully-title'), {
          body: i18n.t('chat.desktop-notifications-enableb-successfully'),
          timeout: 2000,
          onClick: () => {
            window.focus();
            this.close();
          },
        });
      });
    }
  }

  return new Promise((resolve) => {
    defer(() => {
      resolve();
    });
  });
};
